import styles from "./PrivacyPolicyChatgpt.module.css";
import React from "react";

const PrivacyPolicy = () => {
    const Dayjs = require("dayjs");
    Dayjs.locale("es");

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <header className={styles.header}>
          <h1 className={styles.title}>Términos y Condiciones de Uso</h1>
          <p className={styles.subtitle}>Asistente GPT Corporativo</p>
          <div className={styles.updateDate}>
            Fecha de última actualización:{" "}
            <span className={styles.date}>13 de Agosto 2025</span>
          </div>
        </header>

        <div className={styles.introduction}>
          <p>
            El presente documento establece los términos y condiciones
            ("Términos") que regulan el uso del Asistente GPT Corporativo
            ("Asistente"), herramienta tecnológica puesta a disposición por
            <strong> Diseños Exclusivos S.A.S</strong> para uso exclusivo de sus
            empleados, colaboradores y personal autorizado.
          </p>
          <p>
            Al acceder o utilizar el Asistente, el usuario acepta cumplir con
            estos Términos. En caso de no estar de acuerdo, deberá abstenerse de
            utilizar la herramienta.
          </p>
        </div>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>1. Uso Exclusivo Empresarial</h2>
          <div className={styles.subsection}>
            <p>
              <strong>1.1.</strong> El Asistente se proporciona únicamente para
              fines laborales y relacionados con las actividades empresariales
              de Diseños Exclusivos S.A.S
            </p>
            <p>
              <strong>1.2.</strong> Queda estrictamente prohibido utilizar el
              Asistente para:
            </p>
            <ul className={styles.list}>
              <li>
                Actividades personales, recreativas o no relacionadas con las
                funciones laborales.
              </li>
              <li>
                Fines ilícitos, inapropiados o contrarios a la legislación
                vigente.
              </li>
              <li>
                Generación o difusión de contenido ofensivo, discriminatorio,
                difamatorio o que vulnere derechos de terceros.
              </li>
            </ul>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>
            2. Recolección y Tratamiento de Datos
          </h2>
          <div className={styles.subsection}>
            <p>
              <strong>2.1.</strong> El uso del Asistente implica la
              recopilación, almacenamiento y análisis de la información
              ingresada por el usuario, incluyendo pero no limitado a:
            </p>
            <ul className={styles.list}>
              <li>Texto introducido en las conversaciones.</li>
              <li>Resultados y respuestas generadas.</li>
              <li>Metadatos de interacción (fecha, hora, usuario, etc.).</li>
            </ul>

            <p>
              <strong>2.2.</strong> Los datos serán tratados con el único
              propósito de:
            </p>
            <ul className={styles.list}>
              <li>Mejorar el servicio y funcionalidad del Asistente.</li>
              <li>Monitorear el cumplimiento de las políticas de uso.</li>
              <li>
                Garantizar la seguridad y confidencialidad de la información
                empresarial.
              </li>
            </ul>

            <p>
              <strong>2.3.</strong> El usuario es responsable de no introducir
              información personal sensible (propia o de terceros) que no sea
              necesaria para el objetivo laboral correspondiente.
            </p>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>
            3. Confidencialidad y Seguridad
          </h2>
          <div className={styles.subsection}>
            <p>
              <strong>3.1.</strong> La información procesada por el Asistente
              será tratada bajo las políticas de seguridad y confidencialidad de
              Diseños Exclusivos S.A.S.
            </p>
            <p>
              <strong>3.2.</strong> No obstante, dado el carácter tecnológico de
              la herramienta, no se garantiza una seguridad absoluta frente a
              accesos no autorizados, por lo que el usuario debe extremar
              precauciones.
            </p>
            <p>
              <strong>3.3.</strong> El usuario no debe introducir datos
              protegidos por secreto empresarial o contractual salvo que sea
              estrictamente necesario y autorizado.
            </p>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>
            4. Responsabilidad del Usuario
          </h2>
          <div className={styles.subsection}>
            <p>
              <strong>4.1.</strong> El usuario es responsable del contenido que
              introduzca y de las consecuencias derivadas de su uso.
            </p>
            <p>
              <strong>4.2.</strong> Cualquier uso indebido del Asistente podrá
              derivar en acciones disciplinarias conforme a las políticas
              internas de la empresa.
            </p>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>
            5. Limitaciones de la Herramienta
          </h2>
          <div className={styles.subsection}>
            <p>
              <strong>5.1.</strong> El Asistente utiliza modelos de inteligencia
              artificial que pueden generar información inexacta o incompleta.
            </p>
            <p>
              <strong>5.2.</strong> El contenido generado no sustituye el
              criterio profesional, asesoramiento especializado o validación
              humana.
            </p>
            <p>
              <strong>5.3.</strong> Diseños Exclusivos S.A.S no se hace
              responsable por decisiones tomadas exclusivamente con base en
              respuestas del Asistente.
            </p>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>
            6. Modificaciones de los Términos
          </h2>
          <div className={styles.subsection}>
            <p>
              <strong>6.1.</strong> Diseños Exclusivos S.A.S se reserva el derecho
              de modificar estos Términos en cualquier momento, notificando a
              los usuarios por los canales internos correspondientes.
            </p>
            <p>
              <strong>6.2.</strong> El uso continuado del Asistente después de
              cualquier modificación implica la aceptación de los nuevos
              Términos.
            </p>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>7. Aceptación</h2>
          <div className={styles.subsection}>
            <p>
              Al utilizar el Asistente, el usuario declara haber leído,
              comprendido y aceptado los presentes Términos y Condiciones.
            </p>
          </div>
        </section>

        <div className={styles.recommendation}>
          <div className={styles.recommendationIcon}>📌</div>
          <div className={styles.recommendationContent}>
            <h3 className={styles.recommendationTitle}>
              Recomendación importante:
            </h3>
            <p>
              El usuario debe utilizar el Asistente con criterio profesional,
              ingresando únicamente la información necesaria para el objetivo
              empresarial y evitando incluir datos sensibles no autorizados.
            </p>
          </div>
        </div>

        <footer className={styles.footer}>
          <p>© {Dayjs().format("YYYY")} Diseños Exclusivos S.A.S. Todos los derechos reservados.</p>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
